import useSearchResults from '../useSearchResults'

export type MulticityJourneyLabel = {
    from: string
    to: string
}

/** Route labels for multicity journey tabs — from filterData.journeys or time-filter airport codes. */
const useMulticityJourneyLabels = (): MulticityJourneyLabel[] => {
    const { filterData, isMulticity, journeyCount } = useSearchResults()

    if (!isMulticity) {
        return []
    }

    if (filterData?.journeys?.length) {
        return filterData.journeys
    }

    return Array.from({ length: journeyCount }, (_, index) => ({
        from: filterData?.departureTimeFrom?.[index]?.airportCode ?? '',
        to: filterData?.arrivalTimeFrom?.[index]?.airportCode ?? ''
    }))
}

export default useMulticityJourneyLabels
